import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateBundle } from "../services/update-bundle";
import { UpdateBundleRequest } from "@/pages/bundles/types/bundle";

export function useUpdateBundle() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateBundleRequest }) =>
      updateBundle(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bundles"] });
      // A save with `propagate_to_versions` also rewrites the offering's other
      // active versions, so every cached single-bundle fetch is stale — not just
      // the edited one. Keyed ["bundle", id], which ["bundles"] does not match.
      queryClient.invalidateQueries({ queryKey: ["bundle"] });
    },
  });
}
